import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import { PessoaType } from "models/person_type";
import FormClient from "views/admin/clients/components/Form";
import useClients from "views/admin/clients/hooks/useClients";
import ContasPagarForm from "./components/Form";
import ContasPagarTable from "./components/Table";
import useContasPagar from "./hooks/useContasPagar";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const ContasPagarScreen = () => {
  const {
    accountSelected,
    add,
    cancelRef,
    categoria,
    centroCusto,
    closeDelete,
    condicaoPagamentos,
    deletar,
    depto,
    edit,
    error,
    list,
    loading,
    save,
    show,
    showDelete,
    showDeleteModal,
    showModal,
    fornecedores,
    loadFornecedores,
    showError,
    errorMsg,
    errorTitle,
    closeError,
    selectedFornecedor,
    selectedCategoria,
    selectedCentroCusto,
    selectedCondicaoPagamentos,
    selectedDepto,
    changeFornecedor,
    changeCategoria,
    changeCentroCusto,
    changeCondicaoPagamento,
    changeDepto,
    changeInput,
    uploadPictures,
    getLink,
    changeSubCategoria,
    subcategoria,
    selectedSubCategoria,
    addRowItem,
    deleteRow,
    editRow,
    itemList,
    usuario,
    generateParcela,
    changeConta,
    contaFinanceiroLista,
    selectedConta,
    changeUser,
    selectedUser,
    users,
    changeDeptoOrcamento,
    listDepto,
    selectedDeptoOrcamento,
    filiais,
    onChangeFilial,
    selectedFilial

  } = useContasPagar();

  const {
    enderecoList,
    showFormPessoa,
    adicionarContato,
    adicionarEndereco,
    bairroRef,
    cargoContatoRef,
    cepRef,
    changeFilial,
    changeItemPessoa,
    cidadeRef,
    classificacaoList,
    classificacaoRef,
    client,
    complementoRef,
    contatoList,
    contribuinteRef,
    deleteContato,
    showPessoa,
    idTipoRef,
    documentoRef,
    razaoSocialRef,
    nomeFantasiaRef,
    inscricaoMunicipalRef,
    inscricaoEstadualRef,
    tipoPessoaList,
    ruaRef,
    numeroRef,
    estadoRef,
    principalRef,
    loadCEP,
    viaCepEnd,
    deleteEnd,
    emailContatoRef,
    principalContatoRef,
    nomeContatoRef,
    filial,
    telefoneContatoRef,
    pessoaFilial,
    nomeClinteRef,
    editPessoa,
    saveCliente,
    errorCliente,
    errorMsgCliente,
    errorTitleCliente,
    cancelPessoaRef,
    closeErrorPessoa,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta,


  } = useClients();

  const editarPessoa = (item: PessoaType) => {
    if (item === undefined || item === null) {
      showError("Erro!", "Selecione o Fornecedor para editar seus dados!");
    } else {
      editPessoa(item);
    }
  };

  const savePersonData = async () => {
    await saveCliente();
    await loadFornecedores();
  };
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal(false)}
                title={"Contas a Pagar"}
              >
                <ContasPagarForm
                  accountSelected={accountSelected}
                  categoria={categoria}
                  centroCusto={centroCusto}
                  condicaoPagamento={condicaoPagamentos}
                  depto={depto}
                  save={save}
                  show={show}
                  showModal={showModal}
                  editPessoa={editarPessoa}
                  fornecedor={fornecedores}
                  showFormPessoa={showFormPessoa}
                  selectedFornecedor={selectedFornecedor}
                  selectedCategoria={selectedCategoria}
                  selectedCentroCusto={selectedCentroCusto}
                  selectedCondicaoPagamentos={selectedCondicaoPagamentos}
                  selectedDepto={selectedDepto}
                  changeFornecedor={changeFornecedor}
                  changeCentroCusto={changeCentroCusto}
                  changeCategoria={changeCategoria}
                  changeCondicaoPagamento={changeCondicaoPagamento}
                  changeDepto={changeDepto}
                  brandStars={brandStars}
                  textColor={textColor}
                  changeInput={changeInput}
                  uploadPictures={uploadPictures}
                  loading={loading}
                  getLink={getLink}
                  changeSubCategoria={changeSubCategoria}
                  subcategoria={subcategoria}
                  selectedSubCategoria={selectedSubCategoria}
                  generateParcela={generateParcela}
                  addRowItem={addRowItem}
                  deleteRow={deleteRow}
                  editRowItem={editRow}
                  itemList={itemList}
                  user={usuario}
                  changeConta={changeConta}
                  contaFinanceiroLista={contaFinanceiroLista}
                  selectedConta={selectedConta}
                  changeUser={changeUser}
                  selectedUser={selectedUser}
                  users={users}
                  changeDeptoOrcamento={changeDeptoOrcamento}
                  listDepto={listDepto}
                  selectedDeptoOrcamento={selectedDeptoOrcamento}
                  filiais={filiais}
                  onChangeFilial={onChangeFilial}
                  selectedFilial={selectedFilial}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <ContasPagarTable
              add={add}
              cancelRef={cancelRef}
              closeDelete={closeDelete}
              deletar={showDeleteModal}
              edit={edit}
              list={list}
              remove={deletar}
              showDelete={showDelete}
            />

          </SimpleGrid>
        )}
      />

      <FormClient
        enderecoList={enderecoList}
        accountSelected={client}
        brandStars={brandStars}
        error={error}
        loading={loading}
        save={savePersonData}
        nomeRef={nomeClinteRef}
        show={showPessoa}
        showModal={showFormPessoa}
        textColor={textColor}
        idTipoRef={idTipoRef}
        classificacaoRef={classificacaoRef}
        documentoRef={documentoRef}
        razaoSocialRef={razaoSocialRef}
        nomeFantasiaRef={nomeFantasiaRef}
        inscricaoMunicipalRef={inscricaoMunicipalRef}
        inscricaoEstadualRef={inscricaoEstadualRef}
        contribuinteRef={contribuinteRef}
        classificacaoList={classificacaoList}
        tipoPessoaList={tipoPessoaList}
        bairroRef={bairroRef}
        cepRef={cepRef}
        ruaRef={ruaRef}
        numeroRef={numeroRef}
        complementoRef={complementoRef}
        cidadeRef={cidadeRef}
        estadoRef={estadoRef}
        principalRef={principalRef}
        loadCEP={loadCEP}
        viaCepEnd={viaCepEnd}
        adicionarEnd={adicionarEndereco}
        deleteEnd={deleteEnd}
        contatoList={contatoList}
        deleteContato={deleteContato}
        adicionarContato={adicionarContato}
        cargoContatoRef={cargoContatoRef}
        emailContatoRef={emailContatoRef}
        nomeContatoRef={nomeContatoRef}
        principalContatoRef={principalContatoRef}
        telefoneContatoRef={telefoneContatoRef}
        changeItem={changeItemPessoa}
        filial={filial}
        changeFilial={changeFilial}
        pessoaFilial={pessoaFilial}
        adcionarConta={adcionarConta}
        agenciaRef={agenciaRef}
        bancoRef={bancoRef}
        contaList={contaList}
        deleteConta={deleteConta}
        descricaoRef={descricaoRef}
        documentoContaRef={documentoContaRef}
        numeroContaRef={numeroContaRef}
        obsRef={obsRef}
        tipoPessoaRef={tipoPessoaRef}
        tipoRef={tipoRef}
        titularRef={titularRef}

      />

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={closeError}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default ContasPagarScreen;
